import { useErrorToast } from "components/toast/ToastComponet";
import {
  FindBKPsByParmFunction,
  FindCardsServicesFunctions,
  FindResultsBKPFunction,
} from "functions/Services";
import type {
  FindBKPsParms,
  FindResultsBKPsTypes,
  FindServicesTypes,
  ResponseFindBKPs,
} from "types/services";

export function useService() {
  const toast = useErrorToast();

  const findCardsServices = async (): Promise<FindServicesTypes> => {
    try {
      const resp: FindServicesTypes = await FindCardsServicesFunctions();
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findResultsBKPs = async (): Promise<FindResultsBKPsTypes> => {
    try {
      const resp: FindResultsBKPsTypes = await FindResultsBKPFunction();
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findBKPsByParm = async (
    parms: FindBKPsParms
  ): Promise<PaginateProps<ResponseFindBKPs[]>> => {
    try {
      const resp: PaginateProps<ResponseFindBKPs[]> =
        await FindBKPsByParmFunction(parms);
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  return { findCardsServices, findResultsBKPs, findBKPsByParm };
}
